
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('mask',{attrs:{"id":"download-no-circle-a","x":"5.36","y":"4.29","width":"14.29","height":"13.1","maskUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M15.58 13.18l-3 2.75-.23-.21-2.77-2.54a.26.26 0 010-.41.33.33 0 01.45 0l2.23 2.05V6.2a.3.3 0 01.32-.29.31.31 0 01.32.29v8.62l2.23-2.05a.32.32 0 01.23-.09.31.31 0 01.22.09.28.28 0 010 .41","fill":"#fff","fill-rule":"evenodd"}})])]),_c('path',{attrs:{"d":"M15.58 13.18l-3 2.75-.23-.21-2.77-2.54a.26.26 0 010-.41.33.33 0 01.45 0l2.23 2.05V6.2a.3.3 0 01.32-.29.31.31 0 01.32.29v8.62l2.23-2.05a.32.32 0 01.23-.09.31.31 0 01.22.09.28.28 0 010 .41","fill":"#fff","fill-rule":"evenodd"}}),_c('g',{attrs:{"mask":"url(#download-no-circle-a)"}},[_c('path',{attrs:{"fill":"none","d":"M5.36 4.29h14.29v13.1H5.36z"}})]),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"square","stroke-miterlimit":"2.38","stroke-width":".6","d":"M7.25 17.62h10.38"}})])
          )
        }
      }
    